// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updatePipCodeObject = (name, data) => ({
    data,
    name,
    type: actions.UPDATE_PIP_CODE_OBJECT
});



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/update-pip-code-object.js